import ds, { media } from 'designsystem';

import Paragraph from 'elements/Paragraph';

const BorderedDescription = Paragraph.extend`
  border-left: none;
  border-right: 1px solid ${ds.brand('text')}; 
  
  ${media.desktop`
    border-left: 1px solid ${ds.brand('text')}; 
  `}
`;

export default BorderedDescription;



// WEBPACK FOOTER //
// ./src/kentico-blocks/DownloadBar/BorderedDescription.jsx